import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeEInvoiceImportCreate,
  detail: routeEInvoiceImportDetail,
  home: routeEInvoiceImportsHome,
  root: routeEInvoiceImportsRoot,
} = createDoctypeRoutes({
  createName: 'new-e-invoice-import',
  createPath: 'new-e-invoice-import',
  detailName: 'eInvoiceImportDetail',
  doctype: DOCTYPES.E_INVOICE_IMPORT,
  homeName: 'e-invoice-imports-home',
  path: 'e-invoice-imports',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/purchaseInvoices/AddEInvoiceImport.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/purchaseInvoices/ViewEInvoiceImport.vue'),
    list: async () =>
      await import('@/components/viewsExternal/purchaseInvoices/PurchaseInvoiceView.vue'),
  },
})

export {
  routeEInvoiceImportCreate,
  routeEInvoiceImportDetail,
  routeEInvoiceImportsHome,
  routeEInvoiceImportsRoot,
}
